const SingleKeyMessage = () => {
    // Used to create page contents links
    // Extract headings and generate scroll-to links
    const scrollList = document.getElementById('scroll-list');
    const headings = document.querySelectorAll('.single-key-message__body .general-content h2, .single-key-message__body .general-content h3');

    headings.forEach((heading, index) => {
        const headingId = `heading-${index}`;
        //adding an id to each heading so these can be linked to
        heading.setAttribute('id', headingId);

        const listItem = document.createElement('li');
        const link = document.createElement('a');
        link.textContent = heading.textContent;

        // Get the heading level (h1, h2, h3, etc.)
        const headingLevel = heading.tagName.toLowerCase();

        // Create the class name for the <li> element including the heading level
        const liClassName = `single-key-message__scroll-item--${headingLevel}`;
        listItem.classList.add('single-key-message__scroll-item', liClassName);

         // Create the class name for the <a> element
        link.classList.add('single-key-message__scroll-link', 'scroll-link');
        link.href = `#${headingId}`;

        listItem.appendChild(link);
        scrollList.appendChild(listItem);
    });


    // Function to update margin based on window width (so the scroll links doesn't undercut download links)
    function updateMargin() {
        const downloadLinksElement = document.querySelector('.download-links');
        const scrollLinks = document.querySelector('.single-key-message__scroll-links');
        const width = window.innerWidth;

        if (downloadLinksElement) { // Check if .download-links element exists
            const downloadLinksHeight = downloadLinksElement.clientHeight;

            // if width is 1024 or more (lg) the margin bottom will be added 
            if (width >= 1024) {
                scrollLinks.style.marginBottom = `${downloadLinksHeight + 200}px`;
            // else remove the margin
            } else {
                scrollLinks.style.marginBottom = '0';
            }
        }
    }

    // Initial update
    updateMargin();

    // Listen for window resize event
    window.addEventListener('resize', updateMargin);

}

export default SingleKeyMessage;
